<template>
  <section class="w100 h100">
    <el-image :src="path" fit="fill"></el-image>
  </section>
</template>

<script>
  export default {
    props: {
      componentData: {
        type: String
      },
    },
    name: "eleSingleImage",
    data() {
      return {
        path: "",
      }
    },
    methods: {},
    created() {
      if (this.componentData) {
        let data = JSON.parse(this.componentData);
        this.path = data.path
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/lib/showMoudle/eleSingleImage.vue